import { Link, Outlet } from 'react-router-dom';
import {
  Box,
  Button,
  StackLayout,
  UtilityText,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { HEADER_NAV_BAR_DEFAULT_HEIGHT } from '@leagueplatform/solutions-foundation';
import logoWithText from 'assets/eos-health-logo.svg';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { useGetUserProfile } from 'hooks/use-get-user-profile.hook';

/**
 * Minimal chrome for pre-onboarding routes (market/persona selection).
 * Header shows the EOS logo, the user's email, and a Log Out link — no
 * nav links, no user-menu dropdown. This prevents the member from
 * bypassing setup by clicking Home/Benefits/etc. in the standard nav.
 */
export const PreOnboardingLayout = () => {
  const { formatMessage } = useIntl();
  const { data: profile } = useGetUserProfile();

  return (
    <>
      <Box
        as="header"
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 1,
          height: `${HEADER_NAV_BAR_DEFAULT_HEIGHT}px`,
          paddingInline: '$two',
          borderBlockEnd: '$borderWidths$thin solid $onSurfaceBorderSubdued',
          backgroundColor: '$surfaceBackgroundPrimary',
          '@mobile': { paddingInline: '$one' },
        }}
      >
        <img
          src={logoWithText}
          height="32px"
          alt={formatMessage({ id: 'STR_APP_NAME' })}
        />
        <StackLayout
          orientation="horizontal"
          horizontalAlignment="end"
          spacing="$one"
          verticalAlignment="center"
        >
          {profile?.email && (
            <UtilityText size="sm">{profile.email}</UtilityText>
          )}
          <Button
            as={Link}
            to={APP_MANAGED_ROUTES.SIGN_OUT}
            priority="secondary"
            size="small"
          >
            {formatMessage({ id: 'STR_LOG_OUT' })}
          </Button>
        </StackLayout>
      </Box>

      <Box
        as="main"
        id="main-content"
        css={{
          minHeight: '100vh',
          padding: `${HEADER_NAV_BAR_DEFAULT_HEIGHT}px $two $two`,
          backgroundColor: '$surfaceBackgroundPrimary',
        }}
      >
        <Outlet />
      </Box>
    </>
  );
};
